import { Box, Typography } from "@mui/material";

import type { ReactNode } from "react";

export type StateHintProps = {
  testId: string;
  tone: "secondary" | "error";
  children: ReactNode;
};

export function StateHint({ testId, tone, children }: StateHintProps) {
  return (
    <Box
      data-testid={testId}
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        textAlign: "center",
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: tone === "error" ? "error.main" : "text.secondary" }}
      >
        {children}
      </Typography>
    </Box>
  );
}
